import styles from './SvgContainer.module.css';

const SvgContainer = () => {
  return (
    <div className={styles.svgContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="490"
        height="999"
        viewBox="0 0 490 999"
        fill="none"
      >
        <path
          d="M-109.706 912.505C-157.855 1013.42 -266.469 1004.95 -314.757 988.11L-1052.96 763.744L-501.948 -1049.21L-223.89 -1026.61C-174.395 -1013.73 -79.4428 -960.323 -95.5905 -849.684C-115.775 -711.386 -44.6854 -693.683 5.82993 -656.209C56.3453 -618.736 461.225 -393.104 476.202 -262.822C490.824 -135.637 355.929 -62.4009 436.897 54.5931C501.672 148.188 491.433 216.621 484.114 240.702C476.795 264.783 447.222 327.339 341.32 369.06C208.943 421.211 190.274 536.549 200.884 663.387C211.493 790.226 145.048 805.163 82.2237 808.189C19.3993 811.215 -49.5186 786.365 -109.706 912.505Z"
          fill="black"
        />
        <path
          d="M-109.706 912.505C-157.855 1013.42 -266.469 1004.95 -314.757 988.11L-1052.96 763.744L-501.948 -1049.21L-223.89 -1026.61C-174.395 -1013.73 -79.4428 -960.323 -95.5905 -849.684C-115.775 -711.386 -44.6854 -693.683 5.82993 -656.209C56.3453 -618.736 461.225 -393.104 476.202 -262.822C490.824 -135.637 355.929 -62.4009 436.897 54.5931C501.672 148.188 491.433 216.621 484.114 240.702C476.795 264.783 447.222 327.339 341.32 369.06C208.943 421.211 190.274 536.549 200.884 663.387C211.493 790.226 145.048 805.163 82.2237 808.189C19.3993 811.215 -49.5186 786.365 -109.706 912.505Z"
          fill="url(#paint0_linear_462_123)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_462_123"
            x1="-988.257"
            y1="783.539"
            x2="377.513"
            y2="-1201.58"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ED374D" />
            <stop offset="0.505208" stop-color="#FA793F" />
            <stop offset="1" stop-color="#F7F651" />
          </linearGradient>
        </defs>
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="568"
        height="708"
        viewBox="0 0 568 708"
        fill="none"
      >
        <path
          d="M203.442 1527.14C190.136 1638.64 303.165 1697.55 361.343 1713.06L1230.65 1977.27L1781.66 164.32L1491.74 14.2897C1434.76 -5.19434 1308.08 -19.1486 1257.08 80.8999C1193.34 205.96 1112 177.332 1039.11 177.299C966.219 177.266 427.289 116.043 333.475 213.26C241.891 308.166 331.531 449.645 180.209 496.038C59.1525 533.153 27.8628 595.187 20.5437 619.269C13.2246 643.35 4.70263 712.304 84.6324 810.506C184.545 933.257 133.211 1038.67 45.8229 1135.72C-41.5649 1232.77 15.394 1285.22 75.9734 1325.75C136.553 1366.28 220.075 1387.76 203.442 1527.14Z"
          fill="black"
        />
        <path
          d="M203.442 1527.14C190.136 1638.64 303.165 1697.55 361.343 1713.06L1230.65 1977.27L1781.66 164.32L1491.74 14.2897C1434.76 -5.19434 1308.08 -19.1486 1257.08 80.8999C1193.34 205.96 1112 177.332 1039.11 177.299C966.219 177.266 427.289 116.043 333.475 213.26C241.891 308.166 331.531 449.645 180.209 496.038C59.1525 533.153 27.8628 595.187 20.5437 619.269C13.2246 643.35 4.70263 712.304 84.6324 810.506C184.545 933.257 133.211 1038.67 45.8229 1135.72C-41.5649 1232.77 15.394 1285.22 75.9734 1325.75C136.553 1366.28 220.075 1387.76 203.442 1527.14Z"
          fill="url(#paint0_linear_462_124)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_462_124"
            x1="1154.37"
            y1="1954.22"
            x2="1231.47"
            y2="-485.536"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ED374D" />
            <stop offset="0.505208" stop-color="#FA793F" />
            <stop offset="1" stop-color="#F7F651" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
};

export default SvgContainer;